import React, { Component } from 'react';
import classNames from 'classnames';
import ScreenLoaderContainer from '../../../../portal/controls/screenLoaderContainer';
import styles from './style.scss';

export default class Loader extends Component {

    render() {

        return (
            <div className={classNames(styles.ldapUserEntriesLoaderWrapper)}>
                <ScreenLoaderContainer />
            </div>
        );
    }
}